module.exports = __webpack_public_path__ + "static/media/Piercing-mascintimate-lorum.81b901a4.png";